/*
 * Themporium magic layer.
 * Tinsella the wish scout follows the pointer, leaves a stardust trail, and casts a
 * burst of stars on click. On touch screens there is no moving Tinsella at all: only the
 * ambient shooting stars remain, and her static picture stays in the scene.
 * No dependencies. Everything here is decorative: the page works without it.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var canvas = document.getElementById('stardust');
  var sprite = document.getElementById('sprite');
  var spark = document.getElementById('wand-spark');
  var toggle = document.getElementById('tp-magic-toggle');
  var toggleLabel = document.getElementById('tp-magic-toggle-label');
  var live = document.getElementById('tp-live');
  if (!canvas || !sprite) return;
  // The Magic switch lives in the top menu bar (the header, or the holding page's logo bar), so it
  // sticks and scrolls with it. If the header is redrawn in the theme editor it is put back.
  function seatToggle() {
    if (!toggle) return;
    if (document.body.contains(toggle) && toggle.parentElement && toggle.parentElement.classList.contains('tp-has-magic')) return;
    var passwordBar = document.querySelector('.password-header');
    var home = document.querySelector('.header-wrapper') || (passwordBar && passwordBar.parentElement);
    if (!home) return;
    home.classList.add('tp-has-magic');
    home.appendChild(toggle);
  }
  seatToggle();
  document.addEventListener('shopify:section:load', seatToggle);



  var ctx = canvas.getContext('2d');
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fineMq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');

  var COLOURS = ['#F0CB6B', '#FFF6DC', '#C9C8EC', '#F3A9C4'];
  var MAX_PARTICLES = 420;
  var STORE_KEY = 'themporium-magic';
  // Wand tip as a fraction of the sprite's width and height (the star on the painted pose)
  var TIP_X = 0.947;
  var TIP_Y = 0.185;

  var W = 0, H = 0, dpr = 1;
  var particles = [];
  var shooters = [];
  var pointer = { x: 0, y: 0, lastX: 0, lastY: 0, seen: false, movedAt: 0 };
  var pos = { x: 0, y: 0, vy: 0 };
  var dir = 1;          // 1 = facing right, -1 = facing left
  var drift = 0;        // smoothed horizontal travel, used to decide when to turn round
  var enabled = false;
  var rafId = 0;
  var lastFrame = 0;
  var nextShooter = 0;
  var dustDebt = 0;

  function rand(min, max) { return min + Math.random() * (max - min); }
  function pick(list) { return list[(Math.random() * list.length) | 0]; }

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function spriteSize() { return sprite.offsetWidth || 112; }
  function spriteHeight() { return sprite.offsetHeight || 124; }

  /* ---------- particles ---------- */

  function addParticle(p) {
    if (particles.length >= MAX_PARTICLES) particles.shift();
    particles.push(p);
  }

  function dust(x, y, count, spread) {
    for (var i = 0; i < count; i++) {
      var life = rand(500, 1100);
      addParticle({
        kind: Math.random() < 0.3 ? 'star' : 'dot',
        x: x + rand(-spread, spread), y: y + rand(-spread, spread),
        vx: rand(-0.35, 0.35), vy: rand(-0.2, 0.5),
        gravity: 0.012, drag: 0.985,
        size: rand(1.2, 3.4), rot: rand(0, 6.28), spin: rand(-0.06, 0.06),
        life: life, max: life, phase: rand(0, 6.28), colour: pick(COLOURS)
      });
    }
  }

  function burst(x, y, facing) {
    var i, angle, speed, life;
    // A cone of stars thrown forward from the wand
    for (i = 0; i < 26; i++) {
      angle = (facing > 0 ? 0 : Math.PI) + rand(-0.85, 0.85) - 0.25;
      speed = rand(2.2, 7.5);
      life = rand(650, 1300);
      addParticle({
        kind: 'star', x: x, y: y,
        vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed,
        gravity: 0.05, drag: 0.955,
        size: rand(3, 8), rot: rand(0, 6.28), spin: rand(-0.2, 0.2),
        life: life, max: life, phase: rand(0, 6.28), colour: pick(COLOURS)
      });
    }
    // A soft ring of glitter all the way round
    for (i = 0; i < 18; i++) {
      angle = (i / 18) * Math.PI * 2;
      speed = rand(1.2, 2.6);
      life = rand(450, 800);
      addParticle({
        kind: 'dot', x: x, y: y,
        vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed,
        gravity: 0.01, drag: 0.95,
        size: rand(1.4, 2.6), rot: 0, spin: 0,
        life: life, max: life, phase: rand(0, 6.28), colour: pick(COLOURS)
      });
    }
    addParticle({ kind: 'ring', x: x, y: y, vx: 0, vy: 0, gravity: 0, drag: 1, size: 6, rot: 0, spin: 0, life: 480, max: 480, phase: 0, colour: '#F0CB6B' });
  }

  function shootingStar() {
    var fromLeft = Math.random() < 0.5;
    var speed = rand(9, 14);
    var angle = rand(0.28, 0.5);
    shooters.push({
      x: fromLeft ? rand(-80, W * 0.4) : rand(W * 0.6, W + 80),
      y: rand(-40, H * 0.25),
      vx: Math.cos(angle) * speed * (fromLeft ? 1 : -1),
      vy: Math.sin(angle) * speed,
      life: rand(700, 1100), max: 1100
    });
  }

  function drawStar(x, y, r, rot) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rot);
    ctx.beginPath();
    ctx.moveTo(0, -r);
    ctx.quadraticCurveTo(r * 0.18, -r * 0.18, r, 0);
    ctx.quadraticCurveTo(r * 0.18, r * 0.18, 0, r);
    ctx.quadraticCurveTo(-r * 0.18, r * 0.18, -r, 0);
    ctx.quadraticCurveTo(-r * 0.18, -r * 0.18, 0, -r);
    ctx.fill();
    ctx.restore();
  }

  function drawParticles(step, ms) {
    ctx.globalCompositeOperation = 'lighter';
    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      p.life -= ms;
      if (p.life <= 0) { particles.splice(i, 1); continue; }
      p.vx *= Math.pow(p.drag, step);
      p.vy = p.vy * Math.pow(p.drag, step) + p.gravity * step;
      p.x += p.vx * step;
      p.y += p.vy * step;
      p.rot += p.spin * step;
      p.phase += 0.25 * step;
      var t = p.life / p.max;
      if (p.kind === 'ring') {
        ctx.globalAlpha = t * 0.7;
        ctx.strokeStyle = p.colour;
        ctx.lineWidth = 2 * t + 0.5;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size + (1 - t) * 64, 0, Math.PI * 2);
        ctx.stroke();
        continue;
      }
      var alpha = t * (0.65 + 0.35 * Math.sin(p.phase));
      ctx.fillStyle = p.colour;
      if (p.kind === 'star') {
        ctx.globalAlpha = alpha;
        drawStar(p.x, p.y, p.size * (0.6 + 0.4 * t), p.rot);
      } else {
        ctx.globalAlpha = alpha * 0.25;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.size * 2.4, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = alpha;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.size * t + 0.4, 0, Math.PI * 2); ctx.fill();
      }
    }
    ctx.globalAlpha = 1;
  }

  function drawShooters(step, ms) {
    for (var i = shooters.length - 1; i >= 0; i--) {
      var s = shooters[i];
      s.life -= ms;
      s.x += s.vx * step;
      s.y += s.vy * step;
      if (s.life <= 0 || s.y > H + 60 || s.x < -200 || s.x > W + 200) { shooters.splice(i, 1); continue; }
      var t = Math.min(1, s.life / 400);
      var tailX = s.x - s.vx * 14;
      var tailY = s.y - s.vy * 14;
      var grad = ctx.createLinearGradient(s.x, s.y, tailX, tailY);
      grad.addColorStop(0, 'rgba(255, 246, 220, ' + (0.95 * t) + ')');
      grad.addColorStop(1, 'rgba(240, 203, 107, 0)');
      ctx.strokeStyle = grad;
      ctx.lineWidth = 2.4;
      ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(s.x, s.y); ctx.lineTo(tailX, tailY); ctx.stroke();
      ctx.globalAlpha = t;
      ctx.fillStyle = '#FFF6DC';
      drawStar(s.x, s.y, 5, 0);
      ctx.globalAlpha = 1;
      if (Math.random() < 0.5 * step) dust(s.x, s.y, 1, 3);
    }
  }

  /* ---------- Tinsella ---------- */

  function wandTip() {
    var size = spriteSize();
    var localX = dir > 0 ? TIP_X : 1 - TIP_X;
    return { x: pos.x + size * localX, y: pos.y + spriteHeight() * TIP_Y };
  }

  function moveSprite(now, step) {
    var size = spriteSize();
    var idle = now - pointer.movedAt > 2500;

    var dx = pointer.x - pointer.lastX;
    var dy = pointer.y - pointer.lastY;
    var travelled = Math.sqrt(dx * dx + dy * dy);
    pointer.lastX = pointer.x;
    pointer.lastY = pointer.y;

    // Turn round only after a clear change of direction, so she does not flicker
    drift = drift * 0.86 + dx;
    if (drift > 14) dir = 1;
    else if (drift < -14) dir = -1;

    var bob = Math.sin(now * 0.004) * (idle ? 7 : 3);
    var gap = 10;
    var targetX = dir > 0 ? pointer.x - size * TIP_X - gap : pointer.x - size * (1 - TIP_X) + gap;
    var targetY = pointer.y - spriteHeight() * TIP_Y + gap + bob;

    var prevY = pos.y;
    var ease = 1 - Math.pow(1 - 0.2, step);
    pos.x += (targetX - pos.x) * ease;
    pos.y += (targetY - pos.y) * ease;
    pos.vy = pos.vy * 0.8 + (pos.y - prevY) * 0.2;

    var tilt = Math.max(-16, Math.min(16, pos.vy * 2.2)) * dir;
    sprite.style.transform = 'translate3d(' + pos.x.toFixed(1) + 'px,' + pos.y.toFixed(1) + 'px,0) scaleX(' + dir + ') rotate(' + tilt.toFixed(1) + 'deg)';
    spark.style.transform = 'translate3d(' + pointer.x.toFixed(1) + 'px,' + pointer.y.toFixed(1) + 'px,0)';

    // Stardust: more when moving fast, a slow sprinkle from the wand when hovering
    dustDebt += travelled / 9;
    var tip = wandTip();
    while (dustDebt >= 1) {
      dustDebt -= 1;
      dust(pointer.x + (tip.x - pointer.x) * Math.random(), pointer.y + (tip.y - pointer.y) * Math.random(), 1, 4);
    }
    if (dustDebt > 6) dustDebt = 6;
    if (Math.random() < 0.06 * step) dust(tip.x, tip.y, 1, 2);
  }

  function frame(now) {
    if (!enabled) return;
    var ms = Math.min(50, now - (lastFrame || now));
    lastFrame = now;
    var step = ms / 16.67;

    ctx.clearRect(0, 0, W, H);
    if (fly) flyStep(now);
    else if (pointer.seen) moveSprite(now, step);
    if (now > nextShooter) {
      // Shooting stars belong to the sky, so they are rarer once the hero has scrolled away
      if (window.scrollY < H * 0.8 || Math.random() < 0.15) shootingStar();
      nextShooter = now + rand(3500, 8500);
    }
    drawShooters(step, ms);
    drawParticles(step, ms);
    rafId = window.requestAnimationFrame(frame);
  }

  function cast(x, y) {
    sprite.classList.remove('is-casting');
    void sprite.offsetWidth; // restart the wand animation
    sprite.classList.add('is-casting');
    burst(x, y, dir);
  }

  /* ---------- flying between the scene and the cursor ---------- */
  // Switching Magic on sends Tinsella from her picture in the scene to the cursor; switching it off
  // sends her back. Only on mouse devices, when her picture is on screen, and never with reduced motion.

  var fly = null;   // { kind: 'out' | 'back', t0, dur, x0, y0, s0, dirT }

  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  function sceneFairy() {
    var el = document.querySelector('.tp-hero-fairy, .tp-opening-fairy');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (r.width < 20) return null;
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    if (cx < 0 || cx > window.innerWidth || cy < 0 || cy > window.innerHeight) return null;
    return { cx: cx, cy: cy, scale: r.width / spriteSize() };
  }

  // Where the sprite's centre sits while it follows the pointer (same maths as moveSprite)
  function restCentre(facing) {
    var size = spriteSize(), h = spriteHeight(), gap = 10;
    var x = facing > 0 ? pointer.x - size * TIP_X - gap : pointer.x - size * (1 - TIP_X) + gap;
    var y = pointer.y - h * TIP_Y + gap;
    return { x: x + size / 2, y: y + h / 2 };
  }

  function flightTime(x0, y0, x1, y1) {
    var d = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0));
    return Math.max(900, Math.min(1600, 650 + d * 0.9));
  }

  function canFly() { return fineMq.matches && !reduceMq.matches; }

  function launchOut(px, py) {
    var f = sceneFairy();
    if (!f || !canFly()) return false;
    pointer.x = px; pointer.y = py; pointer.lastX = px; pointer.lastY = py;
    pointer.movedAt = performance.now();
    pointer.seen = true;
    var dirT = px >= f.cx ? 1 : -1;
    var end = restCentre(dirT);
    root.classList.add('tp-fairy-away');          // hides her picture at once
    sprite.style.transition = 'none';
    sprite.classList.add('is-visible');
    fly = { kind: 'out', t0: performance.now(), dur: flightTime(f.cx, f.cy, end.x, end.y), x0: f.cx, y0: f.cy, s0: f.scale, dirT: dirT };
    return true;
  }

  function startBack(f) {
    var size = spriteSize(), h = spriteHeight();
    var x0 = pos.x + size / 2, y0 = pos.y + h / 2;
    spark.classList.remove('is-visible');
    fly = { kind: 'back', t0: performance.now(), dur: flightTime(x0, y0, f.cx, f.cy), x0: x0, y0: y0, s0: 1, dirT: f.cx >= x0 ? 1 : -1 };
  }

  function showStaticFairy() {
    // Her picture comes back instantly, as the flying one disappears, so there is never a double
    var els = document.querySelectorAll('.tp-hero-fairy, .tp-opening-fairy');
    els.forEach(function (el) { el.style.transition = 'none'; });
    root.classList.remove('tp-fairy-away');
    void root.offsetWidth;
    window.setTimeout(function () { els.forEach(function (el) { el.style.transition = ''; }); }, 60);
  }

  function flyStep(now) {
    var size = spriteSize(), h = spriteHeight();
    var t = clamp01((now - fly.t0) / fly.dur);
    var e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    var f = null, bx, by, bs;
    if (fly.kind === 'out') {
      var end = restCentre(fly.dirT);
      bx = end.x; by = end.y; bs = 1;
    } else {
      f = sceneFairy();
      if (!f) { finishFlight(); return; }   // her picture has scrolled out of view: land at once
      bx = f.cx; by = f.cy; bs = f.scale;
      fly.dirT = bx >= fly.x0 ? 1 : -1;
    }
    var mx = (fly.x0 + bx) / 2;
    var my = (fly.y0 + by) / 2 - Math.min(170, Math.sqrt((bx - fly.x0) * (bx - fly.x0) + (by - fly.y0) * (by - fly.y0)) * 0.35);
    var a = (1 - e) * (1 - e), b = 2 * (1 - e) * e, c = e * e;
    var x = a * fly.x0 + b * mx + c * bx;
    var y = a * fly.y0 + b * my + c * by;
    var sc = fly.s0 + (bs - fly.s0) * e;

    // She starts and ends facing right, like her picture; in between she faces the way she flies
    var sx;
    if (fly.kind === 'out') sx = 1 + (fly.dirT - 1) * clamp01(e / 0.25);
    else sx = fly.dirT + (1 - fly.dirT) * clamp01((e - 0.75) / 0.25);
    var tilt = Math.sin(t * Math.PI) * 7 * fly.dirT;

    pos.x = x - size / 2;
    pos.y = y - h / 2;
    sprite.style.transform = 'translate3d(' + pos.x.toFixed(1) + 'px,' + pos.y.toFixed(1) + 'px,0) scaleX(' + sx.toFixed(3) + ') scale(' + sc.toFixed(3) + ') rotate(' + tilt.toFixed(1) + 'deg)';

    // A little stardust from the wand on the way
    if (Math.random() < 0.8) dust(x + sx * (TIP_X - 0.5) * size * sc, y + (TIP_Y - 0.5) * h * sc, 1, 3);

    if (t >= 1) finishFlight();
  }

  function finishFlight() {
    var kind = fly ? fly.kind : null;
    var dirT = fly ? fly.dirT : 1;
    fly = null;
    if (kind === 'out') {
      dir = dirT; drift = 0;
      var rest = restCentre(dir);
      pos.x = rest.x - spriteSize() / 2;
      pos.y = rest.y - spriteHeight() / 2;
      sprite.style.transition = '';
      root.classList.remove('tp-fairy-away');      // the magic-on rules keep her picture hidden
      spark.classList.add('is-visible');
      cast(pointer.x, pointer.y);                   // she lands with a wave of her wand
    } else if (kind === 'back') {
      sprite.style.transition = 'none';
      setEnabled(false);                            // hides her, the spark and the stardust
      showStaticFairy();
      window.setTimeout(function () { sprite.style.transition = ''; }, 60);
    }
  }

  /* ---------- pointer events ---------- */

  function showSprite() {
    if (pointer.seen) return;
    pointer.seen = true;
    var size = spriteSize();
    pos.x = pointer.x - size;
    pos.y = pointer.y - spriteHeight() * 0.2;
    pointer.lastX = pointer.x;
    pointer.lastY = pointer.y;
    sprite.classList.add('is-visible');
    spark.classList.add('is-visible');
  }

  window.addEventListener('pointermove', function (e) {
    if (!enabled || e.pointerType === 'touch') return;
    pointer.x = e.clientX;
    pointer.y = e.clientY;
    pointer.movedAt = performance.now();
    showSprite();
  }, { passive: true });

  window.addEventListener('pointerdown', function (e) {
    if (!enabled || fly) return;
    if (e.target.closest && e.target.closest('#tp-magic-toggle')) return;
    if (e.pointerType === 'touch' || !fineMq.matches) return;
    pointer.x = e.clientX;
    pointer.y = e.clientY;
    showSprite();
    cast(e.clientX, e.clientY);
  }, { passive: true });

  document.addEventListener('pointerover', function (e) {
    if (!e.target.closest) return;
    spark.classList.toggle('is-hot', !!e.target.closest('a, button, label, select, [role="button"]'));
    root.classList.toggle('over-field', !!e.target.closest('input, textarea'));
  }, { passive: true });

  document.addEventListener('mouseleave', function () {
    if (fly) return;
    sprite.classList.remove('is-visible');
    spark.classList.remove('is-visible');
    pointer.seen = false;
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { window.cancelAnimationFrame(rafId); lastFrame = 0; }
    else if (enabled) { rafId = window.requestAnimationFrame(frame); }
  });

  window.addEventListener('resize', resize);

  /* ---------- wishes ---------- */
  // Saved in this browser only, keyed by product handle. A wish list page can read the same key.

  var WISH_KEY = 'themporium-wishes';
  var wishCount = document.getElementById('tp-wish-count');
  var wishTotal = document.getElementById('tp-wish-total');

  function readWishes() {
    try { return JSON.parse(window.localStorage.getItem(WISH_KEY) || '[]'); } catch (err) { return []; }
  }
  function writeWishes(list) {
    try { window.localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (err) { /* private mode */ }
  }

  var wishes = readWishes();

  function paintWishes(announce) {
    if (!announce) wishes = readWishes();
    document.querySelectorAll('.tp-wish[data-handle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(wishes.indexOf(btn.getAttribute('data-handle')) !== -1));
    });
    if (wishCount) wishCount.textContent = String(wishes.length);
    if (!announce) return;
    document.dispatchEvent(new CustomEvent('themporium:wishes-changed'));
    if (wishTotal) {
      wishTotal.classList.remove('is-bumped');
      void wishTotal.offsetWidth;
      wishTotal.classList.add('is-bumped');
    }
    if (live) live.textContent = wishes.length === 1 ? '1 wish saved' : wishes.length + ' wishes saved';
  }

  function flyWish(from) {
    if (!enabled || !wishTotal || !from.animate) { paintWishes(true); return; }
    var a = from.getBoundingClientRect();
    var b = wishTotal.getBoundingClientRect();
    var star = document.createElement('div');
    star.className = 'tp-flying-wish';
    star.innerHTML = '<svg viewBox="-10 -10 20 20"><path d="M0,-10 L2.4,-2.4 L10,0 L2.4,2.4 L0,10 L-2.4,2.4 L-10,0 L-2.4,-2.4 Z" fill="#F0CB6B"/></svg>';
    document.body.appendChild(star);
    var x0 = a.left + a.width / 2 - 11, y0 = a.top + a.height / 2 - 11;
    var x1 = b.left + 14, y1 = b.top + b.height / 2 - 11;
    var midX = (x0 + x1) / 2, midY = Math.min(y0, y1) - 90;
    var flight = star.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1) rotate(0deg)' },
      { transform: 'translate(' + midX + 'px,' + midY + 'px) scale(1.5) rotate(200deg)', offset: 0.5 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(0.7) rotate(400deg)' }
    ], { duration: 850, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
    var trail = window.setInterval(function () {
      var r = star.getBoundingClientRect();
      dust(r.left + r.width / 2, r.top + r.height / 2, 2, 3);
    }, 40);
    flight.onfinish = function () {
      window.clearInterval(trail);
      star.remove();
      burst(x1 + 11, y1 + 11, 1);
      paintWishes(true);
    };
  }

  // Delegated, so cards added later (filters, quick add, section reloads) work too
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.tp-wish[data-handle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    var at = wishes.indexOf(handle);
    if (at === -1) { wishes.push(handle); btn.setAttribute('aria-pressed', 'true'); writeWishes(wishes); flyWish(btn); }
    else { wishes.splice(at, 1); writeWishes(wishes); paintWishes(true); }
  });

  paintWishes(false);
  document.addEventListener('shopify:section:load', function () { paintWishes(false); });

  /* ---------- on / off ---------- */

  function readStore() { try { return window.localStorage.getItem(STORE_KEY); } catch (err) { return null; } }
  function writeStore(value) { try { window.localStorage.setItem(STORE_KEY, value); } catch (err) { /* private mode */ } }

  function setEnabled(on) {
    enabled = on;
    root.classList.toggle('magic-on', on);
    root.classList.toggle('pointer-fine', fineMq.matches);
    if (toggle) toggle.setAttribute('aria-pressed', String(on));
    if (toggleLabel) toggleLabel.textContent = on ? 'Magic on' : 'Magic off';
    window.cancelAnimationFrame(rafId);
    if (on) {
      resize();
      lastFrame = 0;
      nextShooter = performance.now() + 1200;
      rafId = window.requestAnimationFrame(frame);
    } else {
      particles.length = 0;
      shooters.length = 0;
      ctx.clearRect(0, 0, W, H);
      sprite.classList.remove('is-visible');
      spark.classList.remove('is-visible');
      pointer.seen = false;
    }
  }

  if (toggle) {
    toggle.addEventListener('click', function (e) {
      if (fly) return;                               // she is mid-flight: let her land first
      var px = e.clientX, py = e.clientY;
      if (!px && !py) {                              // activated from the keyboard: use the button's centre
        var r = toggle.getBoundingClientRect();
        px = r.left + r.width / 2; py = r.top + r.height / 2;
      }
      if (enabled) {
        var home = sceneFairy();
        if (pointer.seen && home && canFly()) {
          // Turning off: she flies home first, and the switch is finished when she lands
          startBack(home);
          toggle.setAttribute('aria-pressed', 'false');
          if (toggleLabel) toggleLabel.textContent = 'Magic off';
          writeStore('off');
          return;
        }
        setEnabled(false);
        writeStore('off');
      } else {
        setEnabled(true);
        writeStore('on');
        launchOut(px, py);
      }
    });
  }

  if (fineMq.addEventListener) {
    fineMq.addEventListener('change', function () { root.classList.toggle('pointer-fine', fineMq.matches); });
  }

  // Respect reduced-motion unless the visitor has explicitly switched the magic on
  var stored = readStore();
  setEnabled(stored ? stored === 'on' : !reduceMq.matches);
})();
